export default __webpack_public_path__ + "static/media/ToroClosed.eebebf9f.jpg";